import { combineReducers } from 'redux';
import { reducer as uiReducer } from 'redux-ui';
import globalReducers from './components/common/redux/reducers/globalReducers';
import weatherReducer from './components/common/redux/reducers/weatherReducer';

export default combineReducers({
  global: globalReducers,
  weather: weatherReducer,
  ui: uiReducer,
  // Add your own reducers here
});
